import { Button } from "../../../components/ui/button";
import evolucaoImage from "../../../assets/evolucao.png";
import profissionaisImage from "../../../assets/profissionais.png";
import { ArrowRight, Blocks, History, Mic, Settings2 } from "lucide-react";
import { useLanguage } from "../../../contexts/LanguageContext";
import { landingLabels } from "../labels";
import { navigate } from "../../../lib/router";

export function Features() {
  const { lang } = useLanguage();
  const t = landingLabels[lang].features;
  return (
    <section id="features" className="w-full py-0 pt-12 pb-12 bg-white">
      <div className="w-full max-w-screen-lg mx-auto px-6">
        <h2 className="text-3xl leading-10 sm:text-4xl md:text-[40px] md:leading-[3.25rem] font-bold tracking-tight text-center">
          {t.heading[0]}<br />
          {t.heading[1]}
        </h2>
        <div className="mt-8 grid sm:grid-cols-2 md:grid-cols-5 lg:grid-cols-3 gap-6">
          {/* Card 1 */}
          <div className="bg-muted rounded-xl pt-6 md:pt-8 pb-6 px-6 col-span-1 md:col-span-2 lg:col-span-1">
            {/* Media 1 Mobile */}
            <img
              src={evolucaoImage}
              alt={t.card1.imgAlt}
              width={1068}
              height={581}
              loading="lazy"
              className="md:hidden mb-6 aspect-video w-full object-cover border rounded-xl"
            />

            <ul className="mt-6 space-y-4">
              {t.card1.items.map((item, i) => (
                <li key={i}>
                  <div className="flex items-start gap-3">
                    {i === 0 ? <History className="shrink-0" /> : <Mic className="shrink-0" />}
                    <p className="-mt-0.5">{item}</p>
                  </div>
                </li>
              ))}
            </ul>

            <Button
              className="mt-12 w-full"
              icon={<ArrowRight />}
              iconPosition="right"
              onClick={() => navigate("/login")}
            >
              {t.card1.cta}
            </Button>
          </div>
          {/* Media 1 Desktop */}
          <img
            src={evolucaoImage}
            alt={t.card1.imgAlt}
            width={1068}
            height={581}
            loading="lazy"
            className="hidden md:block border border-border/80 rounded-xl col-span-1 md:col-span-3 lg:col-span-2 w-full h-full object-cover"
          />

          {/* Media 2 Desktop */}
          <img
            src={profissionaisImage}
            alt={t.card2.imgAlt}
            width={1068}
            height={566}
            loading="lazy"
            className="hidden md:block border border-border/80 rounded-xl col-span-1 md:col-span-3 lg:col-span-2 w-full h-full object-cover object-left"
          />
          {/* Card 2 */}
          <div className="bg-muted rounded-xl pt-6 md:pt-8 pb-6 px-6 col-span-1 md:col-span-2 lg:col-span-1">
            {/* Media 2 Mobile */}
            <img
              src={profissionaisImage}
              alt={t.card2.imgAlt}
              width={1068}
              height={566}
              loading="lazy"
              className="md:hidden mb-6 aspect-video w-full object-cover border rounded-xl object-left"
            />

            <ul className="mt-6 space-y-4">
              {t.card2.items.map((item, i) => (
                <li key={i}>
                  <div className="flex items-start gap-3">
                    {i === 0 ? <Settings2 className="shrink-0" /> : <Blocks className="shrink-0" />}
                    <p className="-mt-0.5">{item}</p>
                  </div>
                </li>
              ))}
            </ul>

            <Button
              className="mt-12 w-full"
              icon={<ArrowRight />}
              iconPosition="right"
              onClick={() => navigate("/login")}
            >
              {t.card2.cta}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
